// Add your language here
const TRANSLATION_LOADING_CONFIG = {
  no: 'Oversettelser lastes inn...',
  en: 'Translations is loading...'
  // ua: 'Переклади завантажуються...'
}

export default TRANSLATION_LOADING_CONFIG
